function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
export const INSET_POSITIONS = ['start', 'center'];
export const DIVIDER_DIRECTIONS = ['horizontal', 'vertical'];
const StyledDivider = styled.div.withConfig({
  componentId: "aui__sc-i3sv1k-0"
})(["", " ", ""], ({
  $direction
}) => `
    border-${$direction === 'vertical' ? 'left' : 'bottom'}: 0.0625rem solid var(--aui-outline-soft);
  `, ({
  $direction,
  $inset,
  $position
}) => `    
    ${$direction === 'vertical' ? `
      margin-top: ${$inset};
      ${$position === 'center' && `margin-bottom: ${$inset};`}
        ` : `
      margin-left: ${$inset};
      ${$position === 'center' && `margin-right: ${$inset};`}
    `}
  `);
export const Divider = ({
  inset = '0rem',
  position = 'start',
  direction = 'horizontal',
  ...props
}) => /*#__PURE__*/React.createElement(StyledDivider, _extends({
  $inset: inset,
  $position: position,
  $direction: direction
}, props, {
  "data-aui": "divider"
}));